import React from 'react';
import SvgIcon from './SvgIcon';

const AircraftAccident = props => {
    return (
        <SvgIcon viewBox="0 0 26 24" fill="none" {...props}>
            <path
                d="M13.553 15.066L4.9 15.9a.5.5 0 01-.31-.071l-2.492-1.523a.5.5 0 01.138-.91l6.873-1.733-6.513-4.18a.5.5 0 01-.22-.515l1.02-5.303a.5.5 0 01.774-.318L6.513 2.93a.5.5 0 01.216.347l.386 2.912 13.008 8.167a2 2 0 01.83 1.265"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.396 19.708L15 15l4.495 3.292L22.891 16 22 19.708l3 2.28H13l4.396-2.28zM15.983 11.73l-1.388-6.963a.5.5 0 00-.21-.316l-2.008-1.359a.5.5 0 00-.772.5l1.05 6.028"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

AircraftAccident.displayName = 'AircraftAccidentIcon';

export default AircraftAccident;
